export const routeProps = {
  path: '/change_lens_amount/(choose|review)',
  exact: true,
};

export default (step = 'choose') => `/change_lens_amount/${step}`;
